import React from "react";
import { CountrySelect } from "react-country-state-city";
import I18n from "i18n-js";

const I18N_COUNTRIES = process.env.I18N_COUNTRIES;

const CountryInput = ({ defaultValue, placeholder, error, onChange }) => (
  <div className="form-group">
    <CountrySelect
      containerClassName={`form-control country ${error ? "error-field" : ""}`}
      inputClassName=""
      src={`${I18N_COUNTRIES}${I18n.locale}`}
      defaultValue={defaultValue}
      autoComplete="nope"
      placeHolder={placeholder}
      onChange={onChange}
    />
    {error && (
      <span className="error">{error}</span>
    )}
  </div>
);

export default CountryInput;
